U.get_associated_item = async function(assoc, home_identifier, show_loader = true) {
	// get the title of the "other side" of the assoc
	let o
	if (assoc.destinationNodeURI.identifier == home_identifier) o = assoc.originNodeURI
	else if (assoc.originNodeURI.identifier == home_identifier) o = assoc.destinationNodeURI
	if (empty(o)) return null

	// try to get the framework identifier from the title
	let arr = o.title.match(/.*\(:(.*):\).*/)
	// we could try alternate strategies for looking up the item here...
	if (!arr) return null
	let framework_identifier = arr[1]

	// get the framework record for the framework, loading it from the server if necessary
	let afr = await U.retrieve_or_load_framework_record(framework_identifier, show_loader)
	if (afr.framework_json_loaded !== true) return null

	// try to get the associated item's node
	let node = afr.tree_nodes_hash[o.identifier]

	if (empty(node)) {
		console.warn(`empty node for association: ${framework_identifier} / ${o.identifier}`)
		return null
	}
	if (empty(afr.cfitems[o.identifier])) {
		console.warn(`empty cfitem for association: ${framework_identifier} / ${o.identifier}`)
		return null
	}

	// start with the associated item's cfitem
	let cfitem = object_copy(afr.cfitems[o.identifier])

	// add these values, which we use in cureum
	cfitem.framework_identifier = framework_identifier
	cfitem.childOf = node.parent?.cfitem.identifier || ''
	cfitem.sequenceNumber = node.tree_key
	// note: use tree_key instead of the assoc's sequenceNumber; that way sort by sequenceNumber should work better for groups of items from different collections

	return cfitem
}

// unfortunately, an item's type can be in either CFItemType or CFItemTypeURI.title
U.item_type = function(item, lower_case = false) {
	let type = item.CFItemType ? item.CFItemType : (item.CFItemTypeURI ? item.CFItemTypeURI.title : '')
	if (lower_case) type = type.toLowerCase()
	return type
}

// easy matcher, optionally ignoring case; item_type_to_check can be a string or array
U.item_type_matches = function(item, item_type_to_check, case_sensitive = false) {
	let type = U.item_type(item)

	if (typeof(item_type_to_check) == 'string') {
		item_type_to_check = [item_type_to_check]
	}

	for (let i of item_type_to_check) {
		if (case_sensitive) {
			if (type == i) return true
		} else {
			if (type.toLowerCase() == i.toLowerCase()) return true
		}
	}

	// if we get to here, no match
	return false
}

// convert educationLevel array to a string (e.g. '9-12'), using `grades` array as the ordered list of possible educationLevels
U.grade_level_display = function(educationLevel, grades, separator) {
	if (empty(educationLevel) || educationLevel.length == 0) return ''

	let s = ''

	// if grades not supplied, use vapp.$store.state.grades
	if (!grades) grades = vapp.$store.state.grades

	let el = educationLevel[0]
	let grade = grades.find(g => { return (g.value == el || ( !isNaN(el*1) && (g.value*1 == el*1) )) })
	if (!empty(grade)) s = grade.text
	else s = el

	if (educationLevel.length == 1) return s

	// caller can optionally send in a separator; by default we just use a plain hyphen
	s += (separator) ? separator : '-'

	el = educationLevel[educationLevel.length - 1]
	grade = grades.find(g => { return (g.value == el || ( !isNaN(el*1) && (g.value*1 == el*1) )) })
	if (!empty(grade)) s += grade.text
	else s += el

	return s
}

// convert from grade_level_display format back to an educationLevel array
U.grade_level_display_to_educationLevel = function(gld, grades, separator) {
	if (empty(gld)) return []

	// caller can optionally send in a separator; by default assume a plain hyphen
	if (!separator) separator = '-'

	// if grades not supplied, use vapp.$store.state.grades
	if (!grades) grades = vapp.$store.state.grades

	let arr = gld.split(separator)
	let lo = $.trim(arr[0])
	let hi = $.trim(arr[1])

	// convert 'K' to 'KG'
	if (lo == 'K') lo = 'KG'
	if (hi == 'K') hi = 'KG'

	let lo_index = grades.findIndex(x=>x.value == lo)
	let hi_index = grades.findIndex(x=>x.value == hi)

	// if we didn't get a lo_index, nothing to parse
	if (lo_index == -1) return []

	// if we have no hi value, it's a single grade
	if (!hi_index) {
		return [grades[lo_index].value]
	}

	// if we get to here process range
	if (lo_index > hi_index) {
		let temp = lo_index
		lo_index = hi_index
		hi_index = temp
	}

	arr = []
	for (let i = lo_index; i <= hi_index; ++i) {
		arr.push(grades[i].value)
	}

	return arr
}

U.case_current_time_string = function() {
	// current time, GMT, in format for lastChangeDateTime
	return date.format(new Date(), 'YYYY-MM-DDTHH:mm:ss+00:00', true)
}

U.local_last_change_date_time = function(s) {
	// convert given lastChangeDateTime string to the local time zone, and format nicely
	return date.format(new Date(s), 'YYYY-MM-DD HH:mm')
}

U.generate_document_uri = function(doc) {
	return new LinkURI({
		title: doc.title,
		identifier: doc.identifier,
		uri: doc.uri,
	})
}

U.generate_child_uri = function(doc, identifier) {
	// sub the document identifier for the incoming identifier in the document's uri
	// so, e.g., `https://case.georgiastandards.org/uri/00fcf0e2-b9c3-11e7-a4ad-47f36833e889` becomes `https://case.georgiastandards.org/uri/00ad9d88-192b-11eb-8deb-0242ac130004`
	return doc.uri.replace(new RegExp(doc.identifier), identifier)
}

// generate the best value for the "title" field of a destinationNodeURI or originNodeURI for a CFAssociation; the incoming item could be either a CFItem or a CFDocument
// this is also used in other situations for generating the corresponding value
U.generate_cfassociation_node_uri_title = function(item, length) {
	// if length === true, it means to generate the full title (for a document) or hcs+fullstatement
	if (length === true) {
		if (!empty(item.title)) return item.title
		if (!empty(item.humanCodingScheme)) return item.humanCodingScheme + ' ' + item.fullStatement
		return item.fullStatement
	}

	let s = ''
	if (!empty(item.humanCodingScheme)) s = item.humanCodingScheme + ' '
	if (!empty(item.fullStatement)) s += item.fullStatement
	if (!empty(item.title)) s = item.title
	if (empty(s)) s = '???'
	s = $.trim(s)

	// if length is false or isn't set, use default 20 characters
	if (!length || typeof(length) != 'number') length = 20
	// use max length characters, to keep file sizes small
	if (s.length > length) s = s.substr(0,length) + '…'
	return s
}

U.count_descendents = function(node) {
	let ct = node.children.length
	for (let child of node.children) {
		ct += U.count_descendents(child)
	}
	return ct
}

// a `framework_record` is an object that includes the raw CASE json for the framework along with some additional non-CASE data about the framework
U.create_framework_record = function(lsdoc_identifier, case_json, ss_framework_data, framework_json_loaded) {
	// make sure case_json has the five top-level components (it must definitionally have a CFDocument already)
	if (empty(case_json.CFItems)) case_json.CFItems = []
	if (empty(case_json.CFAssociations)) case_json.CFAssociations = []
	if (empty(case_json.CFDefinitions)) case_json.CFDefinitions = {}
	if (empty(case_json.CFRubrics)) case_json.CFRubrics = []

	let framework_record = {
		lsdoc_identifier: lsdoc_identifier,		// if this is empty, it means it's a new framework (not yet saved)
		ss_framework_data: new SSFrameworkData(ss_framework_data, lsdoc_identifier),	// this can be empty coming in; if so default values will be set

		// if this is null/false, it means we haven't actually tried to load the full framework json from the server; if it is 'loading', it means we're in the process of loading it (note that this is different than how we handle things in satchel)
		framework_json_loaded: (framework_json_loaded ? framework_json_loaded: false),
		json: case_json,
		tree: null,
		cfitems: {},
		tree_nodes_hash: {},
		associations_hash: {},
	}
	return framework_record
}

U.retrieve_or_create_framework_record = function(framework_identifier, json = {}) {
	// look for this framework's framework_record in the store
	let fr = vapp.framework_records.find(x=>x.lsdoc_identifier==framework_identifier)

	// if framework_record doesn't already exist, create it
	if (!fr) {
		fr = U.create_framework_record(framework_identifier, json)
		vapp.$store.state.framework_records.push(fr)
	}

	// and return it
	return fr
}

U.retrieve_or_load_framework_record = async function(framework_identifier, show_loader = true) {
	let fr = U.retrieve_or_create_framework_record(framework_identifier)
	if (!fr.framework_json_loaded) {
		if (show_loader) U.loading_start()
		try {
			await vapp.$store.dispatch('get_lsdoc', framework_identifier)
		} catch(e) {
			if (show_loader) U.loading_stop()
			console.error(e)
			console.warn(`couldn’t retrieve associated CASE framework ${framework_identifier}`)
			return null
		}
	}
	return fr
}

U.framework_record_load_json = function(framework_record, case_json) {
	// make sure case_json has the five top-level components (it must definitionally have a CFDocument already)
	if (empty(case_json.CFItems)) case_json.CFItems = []
	if (empty(case_json.CFAssociations)) case_json.CFAssociations = []
	if (empty(case_json.CFDefinitions)) case_json.CFDefinitions = {}
	if (empty(case_json.CFRubrics)) case_json.CFRubrics = []

	vapp.$store.commit('set', [framework_record, 'json', case_json])
	vapp.$store.commit('set', [framework_record, 'framework_json_loaded', true])
}

U.framework_record_build_tree = function(framework_record, include_supplemental_branches = false) {
	let cfitems = {}
	let tree_nodes_hash = {}
	// this will hold non-isChildOf assocs, indexed by both sides of the assoc; it will be saved to the framework_record
	let associations_hash = {}
	// this will hold isChildOf assocs, indexed by the parent only; used to speed up processing but not saved to the framework_record
	let is_child_of_hash = {}
	let next_tree_key = 1

	// first build associations_hash / is_child_of_hash
	for (let a of framework_record.json.CFAssociations) {
		if (a.associationType == 'isChildOf') {
			if (!is_child_of_hash[a.destinationNodeURI.identifier]) is_child_of_hash[a.destinationNodeURI.identifier] = []
			is_child_of_hash[a.destinationNodeURI.identifier].push({
				child_identifier: a.originNodeURI.identifier,
				sequence: a.sequenceNumber ?? 0
			})
		} else {
			if (!associations_hash[a.destinationNodeURI.identifier]) associations_hash[a.destinationNodeURI.identifier] = []
			associations_hash[a.destinationNodeURI.identifier].push(a)

			if (!associations_hash[a.originNodeURI.identifier]) associations_hash[a.originNodeURI.identifier] = []
			associations_hash[a.originNodeURI.identifier].push(a)
		}
	}

	// put all is_child_of_hash arrays in order
	for (let id in is_child_of_hash) {
		is_child_of_hash[id].sort((a,b)=>a.sequence - b.sequence)
	}

	// build cfitems hash
	for (let cfitem of framework_record.json.CFItems) {
		cfitems[cfitem.identifier] = cfitem
	}
	
	var build_node = function(cfitem) {
		// for our purposes in cureum, we usually only want one node per cfitem. so if we've already found a node for this cfitem, don't add it (or any of its children) again unless include_supplemental_branches is true
		if (include_supplemental_branches != true) {
			if (!empty(tree_nodes_hash[cfitem.identifier])) {
				return
			}
		}

		// build the node
		var node = {
			tree_key: next_tree_key,
			cfitem: cfitem,
			children: [],
			parent: null,
			sequence: 0,
			open: false,	// in case the component wants to keep track of whether or not nodes are open; see HDCPTreeItem
			selected: false,	// in case the component wants to keep track of selected nodes; see HDCPTreeItem
		}
		++next_tree_key

		// add new node to tree_nodes_hash, indexed by the cfitem identifier -- if it doesn't already exist (the only case where it would already exist is if include_supplemental_branches is true)
		if (empty(tree_nodes_hash[cfitem.identifier])) {
			tree_nodes_hash[cfitem.identifier] = node
		}

		// if the item has children, recursively add them
		if (!empty(is_child_of_hash[cfitem.identifier])) {
			for (let o of is_child_of_hash[cfitem.identifier]) {
				let child_cfitem = cfitems[o.child_identifier]
				if (child_cfitem) {
					let child_node = build_node(child_cfitem)
					if (child_node) {
						child_node.parent = node
						child_node.sequence = o.sequence
						node.children.push(child_node)
					}
				}
			}
		}

		// order children by sequence
		node.children.sort((a,b)=>{
			if (a.sequence && b.sequence) return a.sequence - b.sequence
			// note that sequence *should* always be an integer, and 0 evaluates as false; this is why we do 1 and -1 as shown below
			if (a.sequence && !b.sequence) return 1
			if (b.sequence && !a.sequence) return -1

			// if neither child has a sequence, or they're both the same, sort on cfitem.humanCodingScheme
			if (a.cfitem.humanCodingScheme < b.cfitem.humanCodingScheme) return -1
			if (b.cfitem.humanCodingScheme < a.cfitem.humanCodingScheme) return 1
			return 0
		})

		return node
	}

	framework_record.tree = build_node(framework_record.json.CFDocument)
	framework_record.cfitems = cfitems
	framework_record.tree_nodes_hash = tree_nodes_hash
	framework_record.associations_hash = associations_hash
}
